import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Select } from '@material-ui/core';
import { CircularProgress, Hidden, Typography } from '@material-ui/core/';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import SendIcon from '@material-ui/icons/Send';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import axios from '../axios-default';
import Loader from '../components/Loader';
// import Colors from '../components/Colors'
import TopBar from '../components/TopBar';
import * as authAction from '../store/Auth/Auth.action';
import { easySnackbar } from '../store/Noti/noti.actions';
import { withLang } from '../util/lang';
import frontend_config from '../frontend_config';
import { getWebAbsPath } from '../util/path';
import CountryRedirectCard from '../components/Registration/CountryRedirectCard';

const hostname = window.location.hostname;

const styles = (theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    main: {
        width: 'auto',
        display: 'block',
        [theme.breakpoints.up(500 + 48)]: {
            width: '100%',
        },
    },
    paper: {
        [theme.breakpoints.up(600)]: {
            marginTop: '60px',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    form: {
        width: '100%',
        marginTop: 8,
        textAlign: 'left',
    },
    montserratFont: {
        fontFamily: "'Montserrat', sans-serif",
        '& *': {
            fontFamily: "'Montserrat', sans-serif",
        },
    },
    submit: {
        marginTop: '24px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
        '& input': {
            fontSize: 20,
        }
    },
    dense: {
        marginTop: '16px',
        marginLeft: '0px',
    },
    welcomeTitle: {
        margin: '16px 0px',
        fontSize: 40,
        fontWeight: 600,
    },
    instructions: {
        margin: '10px 0px',
        fontSize: 24,
    },
    progress: {
        marginTop: '48px',
    },
    required: {
        '&:after': {
            content: `'*'`,
            color: 'red',
            marginLeft: '3px',
        },
    },
    errors: {
        listStyleType: 'none',
        color: 'red',
        padding: '2px',
    },
    errorlist: {
        margin: '8px',
    },
    login: {
        backgroundColor: frontend_config?.[hostname]?.main_color_1,
        '&:hover': {
            backgroundColor: frontend_config?.[hostname]?.main_color_2,
        },
    },
    loginLeft: {
        height: '100vh',
        backgroundPosition: 'top center',
        backgroundSize: 'cover',
    },
    contactInfo: {
        fontWeight: '600',
        marginTop: '16px',
        fontSize: 28,
    },
    selectField: {
        '& .MuiOutlinedInput-input': {
            paddingBlock: '10.5px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'grey',
        },
        marginTop: '16px',
    },
});

const backgroundImage = `url("${getWebAbsPath('/img/loginLeft1Blur.png')}")`;

const initialState = {
    gender: 'M',
    first_name: '',
    last_name: '',
    title: undefined,
    email: '',
    password: '',
    confirmPassword: '',
    phone_no: '',
    fax_no: '',
    license_no: '',
    clinic_phone_no: '',
    clinic_website: '',
    sc_customer: '',
    country_id: ['CN'].includes(process.env.REACT_APP_ENV) ? 21 : undefined,
    state_province_id: undefined,
    company_name: '',
    countryList: [],
    errors: {},
    submitting: false,
    data_sharing_consent: false,
    marketing_consent: false,
    countryRegistrationInfoList: [],
    local_entity_id: undefined,
};

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    submitHandler() {
        if (!this.state.submitting) {
            this.setState({ submitting: true }, async () => {
                try {
                    let errors = {};

                    if (!this.state.first_name?.length) {
                        errors['first_name'] = 'First Name is required';
                    }
                    if (!this.state.last_name?.length) {
                        errors['last_name'] = 'Last Name is required';
                    }
                    if (!this.state.title?.length || this.state.title === "none") {
                        errors['title'] = 'Title is required';
                    }
                    if (!this.state.email?.length) {
                        errors['email'] = 'Email is required';
                    }
                    if (!this.state.password?.length) {
                        errors['password'] = 'Password is required';
                    } else if (!this.state.password?.length) {
                        errors['confirmPassword'] = 'Confirm Password is required';
                    } else if (this.state.password !== this.state.confirmPassword) {
                        errors['confirmPassword'] = 'Passwords do not match';
                    }
                    if (!this.state.company_name?.length) {
                        errors['company_name'] = 'Company Name is required';
                    }
                    if (!this.state.license_no?.length) {
                        errors['license_no'] = 'License Number is required';
                    }
                    if (!this.state.phone_no?.length) {
                        errors['phone_no'] = 'Phone Number is required';
                    }
                    if (!this.state.clinic_phone_no?.length) {
                        errors['clinic_phone_no'] = 'Clinic Phone Number is required';
                    }

                    if (!this.state.country_id || this.state.country_id === "none") {
                        errors['country_id'] = 'Country is required';
                    }
                    if ((!this.state.state_province_id || this.state.state_province_id === "none") && this.state.stateProvinceList?.length) {
                        errors['state_province_id'] = 'State Province is required';
                    }
                    if ((!this.state.local_entity_id || this.state.local_entity_id === "none") && this.state.localEntityList?.length) {
                        errors['local_entity_id'] = 'Local Entity is required';
                    }

                    if (Object.keys(errors).length > 0 && errors.constructor === Object) {
                        // this.setState({ errors: errors })
                        await this.props.showSnackbar(Object.values(errors)[0], 'error');
                    } else {
                        this.setState({ errors: errors });
                        await this.props.register(this.state);
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    this.setState({ submitting: false });
                }
            });
        }
    }

    async getRegistrationInfo() {
        let { data } = await axios.get('res/country/registration-info');
        this.setState({ countryRegistrationInfoList: data.country_registration_info });
    }

    async componentDidMount() {
        const { props } = this;
        if (this.state.countryList.length == 0) {
            let { data } = await axios.get('res/country');
            let country = data.country.filter((v) => {
                return v.country_name === 'Hong Kong SAR';
            });
            this.setState({ countryList: data.country });

            await this.getRegistrationInfo();
        }
    }

    async handleChangeData(stateName, value) {
        switch (stateName) {
            case 'gender':
                this.setState({ gender: value });
                break;
            case 'title':
                this.setState({ title: value });
                break;
            case 'first_name':
                this.setState({ first_name: value });
                break;
            case 'last_name':
                this.setState({ last_name: value });
                break;
            case 'email':
                this.setState({ email: value });
                break;
            case 'password':
                this.setState({ password: value });
                break;
            case 'confirmPassword':
                this.setState({ confirmPassword: value });
                break;
            case 'phone_no':
                this.setState({ phone_no: value });
                break;
            case 'fax_no':
                this.setState({ fax_no: value });
                break;
            case 'license_no':
                this.setState({ license_no: value });
                break;
            case 'clinic_phone_no':
                this.setState({ clinic_phone_no: value });
                break;
            case 'clinic_website':
                this.setState({ clinic_website: value });
                break;
            case 'sc_customer':
                this.setState({ sc_customer: value });
                break;
            case 'country':
                this.setState({ country_id: value });
                let {
                    data: { state_province: stateProvince },
                } = await axios.get(`res/state_province/${value}`);
                this.setState({
                    stateProvinceList: stateProvince,
                    state_province_id: stateProvince.length ? this.state.state_province_id : undefined,
                });
                let {
                    data: { local_entity: localEntity },
                } = await axios.get(`res/local_entity/${value}`);
                this.setState({
                    localEntityList: localEntity,
                    local_entity_id: localEntity.length ? this.state.local_entity_id : undefined,
                });
                break;
            case 'state_province':
                this.setState({ state_province_id: value });
                break;
            case 'company_name':
                this.setState({ company_name: value });
                break;
            case 'data_sharing_consent':
                this.setState({ data_sharing_consent: value });
                break;
            case 'marketing_consent':
                this.setState({ marketing_consent: value });
                break;
            case 'local_entity':
                this.setState({ local_entity_id: value });
                break;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.registeredStatus !== this.props.registeredStatus && this.props.registeredStatus) {
            this.props.queueSnackbar('Account created. Please wait for our approval.', 'success');
            this.props.history.push('/login');
        }
    }

    render() {
        const { classes, isLoading } = this.props;
        const { errors } = this.state;

        let registeredStatusText = '';
        if (!this.props.registeredStatus) {
            registeredStatusText = (
                <Typography component="h6" variant="h6" className={classes.welcomeTitle}>
                    <p style={{ color: 'red' }}>{this.props.registeredStatusText}</p>
                </Typography>
            );
        }

        if (this.props.registeredStatus) {
            const { props } = this;
            setTimeout(function () {}, 2000);
        }
        return (
            <Fragment>
                {isLoading ? (
                    <Loader />
                ) : (
                    <Grid container>
                        <TopBar />
                        <Hidden smDown>
                            <Grid
                                item
                                xs={12}
                                md={6}
                                style={{ backgroundImage: backgroundImage }}
                                className={classes.loginLeft}
                            ></Grid>
                        </Hidden>
                        <Grid item xs={12} md={6} style={{ height: '100vh', overflowY: 'scroll' }}>
                            <main className={classes.main}>
                                <Paper className={classNames(classes.paper, classes.montserratFont)} elevation={isWidthUp('sm', this.props.width) ? 2 : 0}>
                                    <div style={{ width: '100%' }}>
                                        <Grid
                                            container
                                            style={{
                                                background: frontend_config?.[hostname]?.main_background_color,
                                                padding: '16px',
                                            }}
                                        >
                                            <Grid item xs={2}></Grid>
                                            <Grid item xs={8} style={{ textAlign: 'center' }}>
                                                <img
                                                    className="loginLogo"
                                                    alt="CT Logo"
                                                    src={getWebAbsPath(frontend_config?.[hostname]?.white_logo_path)}
                                                    style={{ width: '60%' }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container style={{ padding: '16px 24px 24px' }}>
                                            <Grid item xs={12}>
                                                {registeredStatusText}
                                                <Typography
                                                    component="h1"
                                                    variant="h4"
                                                    className={classes.welcomeTitle}
                                                >
                                                    {this.get('welcome')}
                                                </Typography>
                                                <Typography
                                                    component="h2"
                                                    variant="h6"
                                                    align="left"
                                                    className={classes.instructions}
                                                >
                                                    {this.get('pleaseRegister')}
                                                </Typography>
                                                <Divider className="loginHr" />
                                                <form className={classes.form}>
                                                    {/* <p className={classes.required} style={{ fontSize: 18, marginBlockEnd: 0 }}>{this.get(':fields.gender')}</p>
                            <Select
                              value={this.state.gender}
                              onChange={(event) => this.handleChangeData("gender", event.target.value)}
                              style={{
                                width: "100%"
                              }}
                            >
                              <MenuItem value="M">{this.get(':fields.male')}</MenuItem>
                              <MenuItem value="F">{this.get(':fields.female')}</MenuItem>
                            </Select> */}
                                                    <p
                                                        className={classes.required}
                                                        style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                    >
                                                        {this.get(':fields.country')}
                                                    </p>
                                                    <Select
                                                        value={this.state.country_id}
                                                        onChange={(event) =>
                                                            this.handleChangeData('country', event.target.value)
                                                        }
                                                        style={{
                                                            width: '100%',
                                                            fontSize: 20,
                                                            color: !this.state.country_id || this.state.country_id === 'none' ? '#bdbdbd' : 'black',
                                                        }}
                                                        variant="outlined"
                                                        className={classes.selectField}
                                                        defaultValue="none"
                                                    >
                                                        <MenuItem value="none" disabled className={classes.montserratFont}>
                                                            {this.get('placeholder.country')}
                                                        </MenuItem>
                                                        {this.state.countryList.map((v) => (
                                                            <MenuItem value={v.country_id} key={v.country_id} className={classes.montserratFont}>
                                                                {v.country_name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {!!this.state.stateProvinceList?.length && (
                                                        <>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.stateProvince')}
                                                            </p>
                                                            <Select
                                                                value={this.state.state_province_id}
                                                                onChange={(event) =>
                                                                    this.handleChangeData(
                                                                        'state_province',
                                                                        event.target.value
                                                                    )
                                                                }
                                                                style={{
                                                                    width: '100%',
                                                                    fontSize: 20,
                                                                    color: !this.state.state_province_id || this.state.state_province_id === 'none' ? '#bdbdbd' : 'black',
                                                                }}
                                                                variant="outlined"
                                                                className={classes.selectField}
                                                                defaultValue="none"
                                                            >
                                                                <MenuItem value="none" disabled className={classes.montserratFont}>
                                                                    {this.get('placeholder.stateProvince')}
                                                                </MenuItem>
                                                                {this.state.stateProvinceList.map((v) => (
                                                                    <MenuItem
                                                                        value={v.state_province_id}
                                                                        key={v.state_province_id}
                                                                        className={classes.montserratFont}
                                                                    >
                                                                        {v.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </>
                                                    )}

                                                    {!!this.state.localEntityList?.length && (
                                                        <>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.localEntity')}
                                                            </p>
                                                            <Select
                                                                value={this.state.local_entity_id}
                                                                onChange={(event) =>
                                                                    this.handleChangeData(
                                                                        'local_entity',
                                                                        event.target.value
                                                                    )
                                                                }
                                                                style={{
                                                                    width: '100%',
                                                                    fontSize: 20,
                                                                    color: !this.state.local_entity_id || this.state.local_entity_id === 'none' ? '#bdbdbd' : 'black',
                                                                }}
                                                                variant="outlined"
                                                                className={classes.selectField}
                                                                defaultValue="none"
                                                            >
                                                                <MenuItem value="none" disabled className={classes.montserratFont}>
                                                                    {this.get('placeholder.localEntity')}
                                                                </MenuItem>
                                                                {this.state.localEntityList.map((v) => (
                                                                    <MenuItem
                                                                        value={v.local_entity_id}
                                                                        key={v.local_entity_id}
                                                                        className={classes.montserratFont}
                                                                    >
                                                                        {v.local_entity_name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </>
                                                    )}

                                                    {(() => {
                                                        const countryInfo = this.state.countryRegistrationInfoList?.find(c => c.country_id === this.state.country_id);
                                                        return countryInfo ? (
                                                            <CountryRedirectCard 
                                                                header={this.get('countryRedirect.' + countryInfo.info_content.header_key)}
                                                                footer={this.get('countryRedirect.footer')}
                                                                message={countryInfo.info_content.message}
                                                            />
                                                        ) : null;
                                                    })()  
                                                    }

                                                    <Grid container style={{ marginTop: 32 }}>
                                                        <Typography
                                                            component="h4"
                                                            variant="h5"
                                                            className={classes.contactInfo}
                                                        >
                                                            {this.get('contactInfo')}
                                                        </Typography>
                                                        <Grid container item xs={12}>
                                                            <Grid item xs={4} style={{ paddingRight: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.title')}
                                                                </p>
                                                                <Select
                                                                    value={this.state.title}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData('title', event.target.value)
                                                                    }
                                                                    style={{
                                                                        width: '100%',
                                                                        fontSize: 20,
                                                                        color: !this.state.title || this.state.title === 'none' ? '#bdbdbd' : 'black',
                                                                    }}
                                                                    variant="outlined"
                                                                    className={classes.selectField}
                                                                    defaultValue="none"
                                                                >
                                                                    <MenuItem value="none" disabled className={classes.montserratFont}>
                                                                        {this.get('placeholder.title')}
                                                                    </MenuItem>
                                                                    <MenuItem value="Prof." className={classes.montserratFont}>{this.get(':fields.Prof')}</MenuItem>
                                                                    <MenuItem value="Dr." className={classes.montserratFont}>{this.get(':fields.Dr')}</MenuItem>
                                                                    <MenuItem value="Mr." className={classes.montserratFont}>{this.get(':fields.Mr')}</MenuItem>
                                                                    <MenuItem value="Mrs." className={classes.montserratFont}>{this.get(':fields.Mrs')}</MenuItem>
                                                                    <MenuItem value="Ms." className={classes.montserratFont}>{this.get(':fields.Ms')}</MenuItem>
                                                                    <MenuItem value="Miss." className={classes.montserratFont}>{this.get(':fields.Miss')}</MenuItem>
                                                                </Select>
                                                            </Grid>
                                                            <Grid item xs={4} style={{ paddingInline: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.firstName')}
                                                                </p>
                                                                <TextField
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    required
                                                                    fullWidth
                                                                    autoFocus
                                                                    value={this.state.first_name}
                                                                    placeholder={this.get('placeholder.firstName')}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData(
                                                                            'first_name',
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4} style={{ paddingLeft: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.lastName')}
                                                                </p>
                                                                <TextField
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    autoFocus
                                                                    value={this.state.last_name}
                                                                    placeholder={this.get('placeholder.lastName')}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData(
                                                                            'last_name',
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.email')}
                                                            </p>
                                                            <TextField
                                                                className={classNames(classes.textField, classes.dense)}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                autoFocus
                                                                value={this.state.email}
                                                                placeholder={this.get('placeholder.email')}
                                                                onChange={(event) =>
                                                                    this.handleChangeData('email', event.target.value)
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <Grid item xs={6} style={{ paddingRight: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.phoneNo')}
                                                                </p>
                                                                <TextField
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={this.state.phone_no}
                                                                    placeholder={this.get('placeholder.phoneNo')}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData(
                                                                            'phone_no',
                                                                            event.target.value
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6} style={{ paddingLeft: 8 }}>
                                                                <p style={{ fontSize: 28, marginBlockEnd: 0 }}>
                                                                    {this.get(':fields.faxNo')}
                                                                </p>
                                                                <TextField
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={this.state.fax_no}
                                                                    placeholder={this.get('placeholder.faxNo')}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData('fax_no', event.target.value)
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <Grid item xs={6} style={{ paddingRight: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.password')}
                                                                </p>
                                                                <TextField
                                                                    id="password"
                                                                    type="password"
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    autoComplete="new-password"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    value={this.state.password}
                                                                    placeholder={this.get('placeholder.password')}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData('password', event.target.value)
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6} style={{ paddingLeft: 8 }}>
                                                                <p
                                                                    className={classes.required}
                                                                    style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                                >
                                                                    {this.get(':fields.confirmPassword')}
                                                                </p>
                                                                <TextField
                                                                    id="confirmPassword"
                                                                    type="password"
                                                                    className={classNames(classes.textField, classes.dense)}
                                                                    margin="dense"
                                                                    autoComplete="new-password"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    placeholder={this.get('placeholder.confirmPassword')}
                                                                    value={this.state.confirmPassword}
                                                                    onChange={(event) =>
                                                                        this.handleChangeData('confirmPassword', event.target.value)
                                                                    }
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container style={{ marginTop: 32 }}>
                                                        <Typography
                                                            component="h4"
                                                            variant="h5"
                                                            className={classes.contactInfo}
                                                        >
                                                            {this.get('practiceDetails')}
                                                        </Typography>
                                                        <Grid container item xs={12}>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.companyName')}
                                                            </p>
                                                            <TextField
                                                                className={classNames(classes.textField, classes.dense)}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={this.state.company_name}
                                                                placeholder={this.get('placeholder.companyName')}
                                                                onChange={(event) =>
                                                                    this.handleChangeData('company_name', event.target.value)
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.licenseNo')}
                                                            </p>
                                                            <TextField
                                                                className={classNames(classes.textField, classes.dense)}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={this.state.license_no}
                                                                placeholder={this.get('placeholder.licenseNo')}
                                                                onChange={(event) =>
                                                                    this.handleChangeData('license_no', event.target.value)
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <p
                                                                className={classes.required}
                                                                style={{ fontSize: 28, marginBlockEnd: 0 }}
                                                            >
                                                                {this.get(':fields.clinicPhoneNo')}
                                                            </p>
                                                            <TextField
                                                                className={classNames(classes.textField, classes.dense)}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={this.state.clinic_phone_no}
                                                                placeholder={this.get('placeholder.clinicPhoneNo')}
                                                                onChange={(event) =>
                                                                    this.handleChangeData('clinic_phone_no', event.target.value)
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid container item xs={12}>
                                                            <p style={{ fontSize: 28, marginBlockEnd: 0 }}>
                                                                {this.get(':fields.clinicWebsite')}
                                                            </p>
                                                            <TextField
                                                                className={classNames(classes.textField, classes.dense)}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={this.state.clinic_website}
                                                                placeholder={this.get('placeholder.clinicWebsite')}
                                                                onChange={(event) =>
                                                                    this.handleChangeData('clinic_website', event.target.value)
                                                                }
                                                            />
                                                        </Grid>
                                                    </Grid>       

                                                    {this.state.countryRegistrationInfoList.find(info => info.country_id === this.state.country_id)?.show_consent_checkbox && (
                                                                <Grid container style={{ marginTop: 32, padding: "16px 32px" }}>
                                                                    <Grid container item xs={12} style={{ paddingBlock: 8 }}>
                                                                        <FormControlLabel
                                                                            style={{ alignItems: 'flex-start', gap: 16, fontSize: 24 }}
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.data_sharing_consent}
                                                                                    style={{padding: 0}}
                                                                                    onChange={(event) =>
                                                                                        this.handleChangeData('data_sharing_consent', event.target.checked)
                                                                                    }
                                                                                />
                                                                            }
                                                                            label={this.get('dataSharingConsent')}
                                                                        />
                                                                    </Grid>
                                                                    <Grid container item xs={12} style={{ paddingBlock: 8 }}>
                                                                        <FormControlLabel
                                                                            style={{ alignItems: 'flex-start', gap: 16, fontSize: 24 }}
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.marketing_consent}
                                                                                    style={{padding: 0}}
                                                                                    onChange={(event) =>
                                                                                        this.handleChangeData('marketing_consent', event.target.checked)
                                                                                    }
                                                                                />
                                                                            }
                                                                            label={this.get('marketingConsent')}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            )                                                  
                                                    }

                                                    <Grid style={{marginTop: 32}}>
                                                        {!(this.state.countryRegistrationInfoList?.find(info => info.country_id === this.state.country_id)?.hide_register) && (
                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                color="primary"
                                                                disabled={this.state.submitting}
                                                                className={classes.login}
                                                                onClick={this.submitHandler.bind(this)}
                                                                style={{ marginBottom: 16, fontSize: 20 }}
                                                            >
                                                                {this.state.isVerifying ? (
                                                                    <CircularProgress style={{ color: 'white' }} />
                                                                ) : (
                                                                    <div style={{ color: 'white' }}>
                                                                        {this.get(':const.register')}
                                                                        <SendIcon
                                                                            style={{
                                                                                margin: '0px 8px',
                                                                                verticalAlign: 'middle',
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Button>
                                                        )}
                                                        <Link
                                                            to="/login"
                                                            style={{
                                                                textDecoration: 'none',
                                                                color: 'black',
                                                            }}
                                                        >
                                                            <Button
                                                                variant="outlined"
                                                                style={{
                                                                    textAlign: 'left',
                                                                    border: 'black solid 1px',
                                                                    width: '100%',
                                                                    fontSize: 20,
                                                                }}
                                                            >
                                                                {this.get(':const.loginInstead')}
                                                            </Button>
                                                        </Link>
                                                    </Grid>
                                                    <p style={{ color: 'red' }}>{this.state.errorMsg}</p>
                                                </form>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Paper>
                            </main>
                        </Grid>
                    </Grid>
                )}
            </Fragment>
        );
    }
}

Register.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => {
    return {
        registeredStatus: store.auth.registeredStatus,
        registeredStatusText: store.auth.registeredStatusText,
        isLoading: store.loading.isLoading,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        register: (state) => dispatch(authAction.register(state)),
        showSnackbar: (msg, variant) => dispatch(easySnackbar(msg, variant)),
        queueSnackbar: (msg, variant) => dispatch(easySnackbar(msg, variant, true)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withWidth()(withLang(Register, 'Register')))));
